<template>
    <div>
        <div @click="$emit('click')" class="my-message-bubble bg-blue-400 hover:bg-blue-500 duration-200 cursor-pointer text-white border my-rounded shadow p-6 mb-3 w-5/6 md:w-3/4 ml-auto">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/processes/cards/tchat/Components/MyMessageBubble.vue